import { Text, TextInput } from '@mantine/core';
import type { TextInputProps } from '@mantine/core';

interface LimitedTextInputProps extends Omit<TextInputProps, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}

const LimitedTextInput = ({
  value,
  onChange,
  maxLength = 30,
  ...props
}: LimitedTextInputProps) => {
  return (
    <TextInput
      value={value}
      onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
      variant="filled"
      maxLength={maxLength}
      rightSection={
        <Text
          size="xs"
          c="dimmed"
        >
          {value.length}/{maxLength}
        </Text>
      }
      {...props}
    />
  );
};

export { LimitedTextInput };
